<template>
	<div class="form-group" :class="[{ 'with-counter': limit }, componentClass, activeClass]">
		<validation-provider v-slot="{ errors, classes }" :rules="rules" :vid="vid">
			<textarea
				:id="name"
				:name="name"
				:class="[{ autoresize: autoresize, 'with-counter': limit }, classes]"
				class="form-control"
				autocomplete="off"
				v-bind="$attrs"
				:value="value"
				:maxlength="maxLength"
				@input="$emit('input', $event.target.value)"
			/>
			<span v-if="limit" class="remaining-chars">{{ remainingChars }} {{ $t('Misc.RemainingChars') }}</span>
			<label v-if="showLabel" :for="name">
				{{ $t(label) }}{{ requiredMark }} <span v-if="showErrors" class="form-error">{{ errors[0] }}</span>
			</label>
		</validation-provider>
	</div>
</template>

<script>
import Helpers from '@/mixins/Helpers'
import { setResizeListeners } from '@/assets/js/autoresize.js'

export default {
	name: 'FormTextarea',
	mixins: [Helpers],
	inheritAttrs: false,
	props: {
		autoresize: {
			type: Boolean,
			default: false,
		},
		componentClass: {
			type: String,
			default: '',
		},
		forceRequiredMark: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: '',
		},
		limit: {
			type: Boolean,
			default: false,
		},
		limitThreshold: {
			type: Number,
			default: 0,
		},
		name: {
			type: String,
			required: true,
		},
		rules: {
			type: String,
			default: '',
		},
		showErrors: {
			type: Boolean,
			default: false,
		},
		value: {
			type: String,
			default: '',
		},
		vid: {
			type: String,
			default: '',
		},
	},
	computed: {
		activeClass() {
			return this.value !== '' && this.value !== null ? 'field-active' : ''
		},
		maxLength() {
			return this.limit ? this.limitThreshold : 10000
		},
		remainingChars() {
			return this.limitThreshold - (this.value ? this.value.length : 0)
		},
	},
	mounted() {
		setResizeListeners(this.$el, '.autoresize')
	},
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/FormTextarea.vue